<template>
  <div>

    <div class="flex justify-center">
      <span class=" mb-5 text-lg text-black text-4xl font-bold">All-in-One Agile Suite</span>
    </div>

    <div class="flex justify-center">
      <img height="100" width="100" src="/images/logo.png"
           class="shadow-lg w-45 h-45   bg-white rounded-full "/>
    </div>
    <div class="text-center mt-5 text-lg text-black text-lg font-bold">
      AgileBot <small class="text-gray-500 text-sm font-thin">v2.0</small>
    </div>
    <div class="flex justify-center">
      <button
          @click="addToSlack"
          type="button"
          class="text-2xl focus:outline-none block px-4 lg:px-4 bg-blue-500 hover:bg-blue-300 text-white  mt-2 mr-2 py-3 px-6  font-bold rounded-full inline-flex">
        <img src="https://cdn.worldvectorlogo.com/logos/slack-new-logo.svg" alt="slack logo"
             class="w-6 h-6 mr-3 mt-1">
        <span>Add to Slack</span>
      </button>
    </div>
    <div class="flex justify-center">
      <span class=" text-md text-black font-bold">30 day free trial</span>
    </div>

  </div>
</template>

<script>


export default {
  components: {},
  methods: {
    addToSlack() {
      window.location.href = window.location.origin + '/slack/install-app/agile-bot';
    }
  },
  created() {

  },
  setup() {

  },
  data() {

  }
}
</script>

